_options$series2